import BaseChannel from '@square/dashboard-data/adapters/channels/base-channel';
export default class Integration extends BaseChannel {}